import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { Layout } from './components/Layout';
import { AuthScreen } from './screens/AuthScreen';
import { Dashboard } from './screens/Dashboard';
import { NewProject } from './screens/NewProject';
import { ProjectWorkspace } from './screens/ProjectWorkspace';
import { MappingReview } from './screens/MappingReview';
import { CountSheet } from './screens/CountSheet';
import { Bom } from './screens/Bom';
import { Costing } from './screens/Costing';
import { Outputs } from './screens/Outputs';
import { Admin } from './screens/Admin';
import { Placeholder } from './screens/Placeholder';

export function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="auth-wrap"><div className="muted">Loading…</div></div>;
  }
  if (!user) return <AuthScreen />;

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/new" element={<NewProject />} />
        <Route path="/projects/:id" element={<ProjectWorkspace />} />
        <Route path="/projects/:id/mapping" element={<MappingReview />} />
        <Route path="/projects/:id/count" element={<CountSheet />} />
        <Route path="/projects/:id/bom" element={<Bom />} />
        <Route path="/projects/:id/costing" element={<Costing />} />
        <Route path="/projects/:id/outputs" element={<Outputs />} />
        {/* §14 screens — wired in later phases */}
        <Route path="/upload" element={<Placeholder title="Document Upload" phase="Phase 1" />} />
        <Route path="/analysis" element={<Placeholder title="Document Analysis" phase="Phase 1" />} />
        <Route path="/systems" element={<Placeholder title="System Selection" phase="Phase 1" />} />
        <Route path="/count" element={<Placeholder title="Estimator Count Sheet" phase="Phases 2–4" />} />
        <Route path="/bom" element={<Placeholder title="BOM Builder" phase="Phase 5" />} />
        <Route path="/pricing" element={<Placeholder title="Pricing Manager" phase="Phase 7" />} />
        <Route path="/estimate" element={<Placeholder title="Estimate Builder" phase="Phase 8" />} />
        <Route path="/proposals" element={<Placeholder title="Proposal Builder" phase="Phase 9" />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
